import { isMemberPhotoResponse, } from '@urbanik/api-contracts';
export class MemberPhotoApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
    }
}
async function json(url, init) {
    let response;
    try {
        response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: { Accept: 'application/json', ...(init?.headers ?? {}) },
        });
    }
    catch {
        throw new MemberPhotoApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const payload = await response.json().catch(() => null);
    const message = payload && typeof payload.message === 'string'
        ? payload.message
        : 'No pudimos completar la solicitud.';
    const kinds = {
        400: 'validation',
        401: 'unauthorized',
        403: 'forbidden',
        404: 'not-found',
        409: 'conflict',
        413: 'too-large',
        415: 'unsupported',
        422: 'validation',
        503: 'unavailable',
    };
    if (!response.ok)
        throw new MemberPhotoApiError(kinds[response.status] ?? 'unavailable', message);
    if (!isMemberPhotoResponse(payload))
        throw new MemberPhotoApiError('unavailable', 'El contrato fotográfico es inválido.');
    return payload;
}
const root = (base, id) => `${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}`;
export const getMemberPhoto = (base, id, signal) => json(`${root(base, id)}/photo`, { signal: signal ?? null });
export const uploadMemberPhoto = (base, id, file) => {
    const body = new FormData();
    body.append('photo', file);
    return json(`${root(base, id)}/photos`, { method: 'POST', body });
};
export const approveMemberPhoto = (base, id, photoId, input) => json(`${root(base, id)}/photos/${encodeURIComponent(photoId)}/approve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
});
export const rejectMemberPhoto = (base, id, photoId, input) => json(`${root(base, id)}/photos/${encodeURIComponent(photoId)}/reject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
});
